import React from 'react'
import { Link } from 'react-router-dom'

export default function BlogInfo() {
  return (
    <>
      
   <section id="Blog-section">
    <div className="row blogbox">
        <div className="col-lg-6 col-md-6">
            <div className="image">
                <img src="/images/blog/Image1.jpg" alt="" />
            </div>
        </div> 
        <div className="col-lg-6 col-md-6">
            <div className="blog-detail">
                <h4>The Cotton-Jersery Zip-up Hoodie</h4>
                <p>Kickstarter man braid godard color booking. Raclette waistcoat selfies yr wolf chartreuse hexagon 
                    irony , godard </p>
                    <a >CONTINUE READING</a>
            </div>
        </div> 
    </div>



    <div className="row blogbox">
        <div className="col-lg-6 col-md-6">
            <div className="image">
                <img src="/images/blog/image2.jpg" alt="" />
            </div>
        </div> 
        <div className="col-lg-6 col-md-6">
            <div className="blog-detail">
                <h4>The Cotton-Jersery Zip-up Hoodie</h4>
                <p>Kickstarter man braid godard color booking. Raclette waistcoat selfies yr wolf chartreuse hexagon 
                    irony , godard </p>
                    <a>CONTINUE READING</a>
            </div>
        </div> 
    </div>

    <div className="row blogbox">
        <div className="col-lg-6 col-md-6">
            <div className="image">
                <img src="/images/blog/image3.jpg" alt="" />
            </div>
        </div> 
        <div className="col-lg-6 col-md-6">
            <div className="blog-detail">
                <h4>The Cotton-Jersery Zip-up Hoodie</h4>
                <p>Kickstarter man braid godard color booking. Raclette waistcoat selfies yr wolf chartreuse hexagon 
                    irony , godard </p>
                    <a>CONTINUE READING</a>
            </div>
        </div> 
    </div>

    <div className="row blogbox">
        <div className="col-lg-6 col-md-6">
            <div className="image">
                <img src="/images/blog/image4.jpg" alt="" />
            </div>
        </div> 
        <div className="col-lg-6 col-md-6">
            <div className="blog-detail">
                <h4>The Cotton-Jersery Zip-up Hoodie</h4>
                <p>Kickstarter man braid godard color booking. Raclette waistcoat selfies yr wolf chartreuse hexagon 
                    irony , godard </p>
                    <a >CONTINUE READING</a>
            </div>
        </div> 
    </div>

    <div className="row blogbox">
        <div className="col-lg-6 col-md-6">
            <div className="image">
                <img src="/images/blog/image5.jpg" alt="" />
            </div>
        </div> 
        <div className="col-lg-6 col-md-6">
            <div className="blog-detail">
                <h4>The Cotton-Jersery Zip-up Hoodie</h4>
                <p>Kickstarter man braid godard color booking. Raclette waistcoat selfies yr wolf chartreuse hexagon 
                    irony , godard </p>
                    <a >CONTINUE READING</a>
            </div>
        </div> 
    </div>

    <div className="row blogbox">
        <div className="col-lg-6 col-md-6">
            <div className="image">
                <img src="/images/blog/image6.jpg" alt="" />
            </div>
        </div> 
        <div className="col-lg-6 col-md-6">
            <div className="blog-detail">
                <h4>The Cotton-Jersery Zip-up Hoodie</h4>
                <p>Kickstarter man braid godard color booking. Raclette waistcoat selfies yr wolf chartreuse hexagon 
                    irony , godard </p>
                    <a >CONTINUE READING</a>
            </div>
        </div> 
    </div>

    <div className="row blogbox">
        <div className="col-lg-6 col-md-6 col-sm-8">
            <div className="image">
                <img src="/images/blog/image7.jpg" alt="" />
            </div>
        </div> 
        <div className="col-lg-6 col-md-6 col-sm-4">
            <div className="blog-detail">
                <h4>The Cotton-Jersery Zip-up Hoodie</h4>
                <p>Kickstarter man braid godard color booking. Raclette waistcoat selfies yr wolf chartreuse hexagon 
                    irony , godard </p>
                    <a >CONTINUE READING</a>
            </div>
        </div> 
    </div>
   </section>

    </>
  )
}
